import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Calendar } from 'lucide-react';

const CATEGORY_COLORS = {
  'Fundraisers': 'bg-amber-100 text-amber-800',
  'Community Support': 'bg-blue-100 text-blue-800',
  'Health Initiatives': 'bg-emerald-100 text-emerald-800',
};

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const CommunityUpdatesPreview = ({ recentUpdates }) => {
  if (!recentUpdates || recentUpdates.length === 0) return null;

  return (
    <section className="py-12 bg-white" data-testid="updates-preview-section">
      <div className="px-6">
        <p className="text-xs text-[#4B5563] text-center mb-6 max-w-lg mx-auto leading-relaxed">
          We share real updates &mdash; not assumptions. Every story reflects actual work happening in the communities we serve.
        </p>
        <div className="flex items-center justify-between mb-6">
          <div>
            <p className="text-sm uppercase tracking-[0.15em] text-[#BA1826] font-semibold mb-1">
              Latest News
            </p>
            <h2 className="font-heading text-2xl sm:text-3xl font-bold text-[#0A0A0A]">
              Community Updates
            </h2>
          </div>
          <Link
            to="/updates"
            className="text-sm text-[#BA1826] font-semibold hover:underline flex items-center gap-1"
            data-testid="view-all-updates-btn"
          >
            View All <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="grid md:grid-cols-2 gap-4">
          {recentUpdates.slice(0, 4).map((update) => (
            <Link
              to="/updates"
              key={update.id}
              className="group bg-white border border-[#E5E7EB] rounded-lg overflow-hidden card-hover"
              data-testid={`home-update-${update.id}`}
            >
              {update.image_url && (
                <div className="aspect-[16/8] overflow-hidden">
                  <img
                    src={update.image_url}
                    alt={update.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
              )}
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className={`text-[10px] font-semibold px-2 py-0.5 rounded-full ${CATEGORY_COLORS[update.category] || 'bg-gray-100 text-gray-700'}`}>
                    {update.category}
                  </span>
                  <span className="flex items-center gap-1 text-[10px] text-[#4B5563]">
                    <Calendar className="w-3 h-3" />
                    {update.date === 'Coming Soon' ? 'Coming Soon' : new Date(update.date + 'T00:00:00').toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
                  </span>
                </div>
                <h3 className="font-heading text-sm font-bold text-[#0A0A0A] mb-1 leading-snug group-hover:text-[#BA1826] transition-colors">
                  {update.title}
                </h3>
                <p className="text-xs text-[#4B5563] line-clamp-2">{update.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
